import React from 'react'
import { Routes, Route } from 'react-router-dom';
import { router } from './route-menu'

export default function RouteView() {

    return (
        <Routes>
            {
                router.map(item => (
                    <Route
                        key={item.key}
                        exact
                        path={item.key}
                        element={item.mode}
                    />
                ))
            }
        </Routes>
    )
}
